import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new';
import FormError from 'src/core/gd-form/common/form-error/form-error';

import TaskStatusSelector from "core/gd-ui/select-status/task/task";
import TaskIcon from 'core/gd-components/icons/task-icon/task-icon';
import TaskStatusManager from "src/core/gd/manager/task-status-manager";

class ModalActionStatus extends React.Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        companyId: PropTypes.string.isRequired,
        projectId: PropTypes.string,
        itemsGroupedByType: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.string, // type is either 'project' or taskTypeId
            items: PropTypes.array,
        })).isRequired,
    };

    constructor(props) {
        super(props);

        let initFormData = {};
        let fields = {};
        _.map(this.props.itemsGroupedByType, g=>{
            //skip projects for now
            if (g.type === "project") return;

            const label = g.type === "project" ? "Project Status" : gd.session.taskTypes.get(g.type).name + " Types Status";
            initFormData[g.type] = null;
            fields[g.type] = {
                type: 'select',
                label: label,
                isRequired: true
            }
        });

        if (this.props.projectId) {
            const statusesOverridden = TaskStatusManager.getProjectStatusesOverride(this.props.projectId).overridden;
            if (statusesOverridden)
                fields['tasks'] = {
                    type: 'select',
                    label: "Tasks statuses",
                    isRequired: true
                };
        }

        const formStructure = {
            fields: fields,
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.onSubmit(result);
    }

    onStatusSelect = (id, value) => {
        if (id === 'overridden') {
            _.map(this.props.itemsGroupedByType, g=>{
                //skip projects for now
                if (g.type === "project") return;
                this.form.onFormComponentValueChange(g.type,value);
            });
            this.form.onFormComponentValueChange('tasks',value); //just for isRequired error
        } else {
            this.form.onFormComponentValueChange(id,value);
        }
    }

    renderByTaskType() {
        const { projectId } = this.props;

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="tbl">
                    {_.map(this.props.itemsGroupedByType, tg=>{
                        //skip projects for now
                        if (tg.type === "project") return;

                        let label;
                        if (tg.type === "project"){
                            label = (
                                <div className="label">
                                    <div className="i5-folder-open group-icon"> </div>
                                    <div className="name">Projects</div>
                                    <div className="i5-long-arrow-right arrow-icon"> </div>
                                </div>
                            );
                        } else {
                            const taskType = gd.session.taskTypes.get(tg.type);
                            label = (
                                <div className="label">
                                    <div className="name">
                                        <TaskIcon className="task-icon" taskType={taskType}/>
                                        {taskType.name}
                                    </div>
                                    <div className="i5-long-arrow-right arrow-icon"> </div>
                                </div>
                            );
                        }

                        return (
                            <div key={tg.type} className="row">
                                {label}
                                <div className="element">
                                    <TaskStatusSelector className="action-task-status"
                                                        renderValue="form"
                                                        projectId={projectId}
                                                        taskTypeId={tg.type}
                                                        value={null}
                                                        placeholder="Select status"
                                                        onUserSelect={this.onStatusSelect.bind(this,tg.type)}
                                                        disabled={projectId ? !gd.ac.check.project.standardAccess(projectId) : false}
                                                        attachment="top center"
                                                        targetAttachment="bottom center"
                                                        targetOffset="0 0"/>
                                    <FormError form={this.form} name={tg.type}/>
                                </div>
                            </div>
                        )}
                    )}
                </div>
            </Form>
        );
    }

    renderOverridden() {
        const { projectId } = this.props;

        return (
            <Form form={this.form} submitLabel="Save" >
                <div className="tbl">
                    <div className="row">
                        <div className="label">
                            <div className="name">Tasks</div>
                            <div className="i5-long-arrow-right arrow-icon"> </div>
                        </div>
                        <div className="element">
                            <TaskStatusSelector className="action-task-status"
                                                renderValue="form"
                                                projectId={projectId}
                                                taskTypeId={null}
                                                value={null}
                                                placeholder="Select status"
                                                onUserSelect={this.onStatusSelect.bind(this,'overridden')}
                                                disabled={!gd.ac.check.project.standardAccess(projectId)}
                                                attachment="top center"
                                                targetAttachment="bottom center"
                                                targetOffset="0 0"/>
                            <FormError form={this.form} name="tasks"/>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }

    render() {
        const statusesOverridden = this.props.projectId ? TaskStatusManager.getProjectStatusesOverride(this.props.projectId).overridden : false;
        return statusesOverridden ? this.renderOverridden() : this.renderByTaskType();
    }
}

module.exports = ModalActionStatus;